import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { Observable, Subscription, of } from 'rxjs';
import { EventService } from 'src/app/core/services/event.service';
import { DevelopmentsService } from '../../../services/developments.services';
import { catchError, debounceTime, map, mapTo, distinctUntilChanged } from 'rxjs/operators';
import { WaitForElementService } from 'src/app/core/services/wait-for-element.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { FlatpickrDefaultsInterface } from 'angularx-flatpickr/flatpickr-defaults.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { PaymentConditionsModel } from '../../../models/payment-conditions.model';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: "app-details-developments",
  templateUrl: "./details.component.html",
  styleUrls: ["./details.component.scss"],
})
export class DetailsDevelopmentsComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input() detailsForm: any;
  @Input() allAgents: any;
  @Input() dataToFormInitDetails: any;
  @Input() quantityAvailable!: number;
  @Input() agents: any;
  @Input() propertyAgentsData: any;
  @Input() canChangeBusinessStatus: any;
  @Input() isUpdate: boolean = false;
  stores: any;
  propertyTypes: any;
  conditions: any;
  businessStatus: any;
  saleId: any;
  typeRent: any;
  rentIds!: any[];
  ec: any;
  businessTypes: any;
  currencies: any;
  subscription!: Subscription;
  subscriptionSubmitted!: Subscription;
  propertyDetailsForm!: FormGroup;
  @Input()
  submitted: boolean = false;
  selectDefaultStore: any;
  type: number = 0;
  propertyTypes2: any;
  isPropertyType = false;
  properties: any = [];
  isView = false;
  legislations: any;
  @Input()
  property: any;
  isNproperty = false;
  isRefValid = true;
  ref = "";
  isShowUseLicense = false;
  nproperties: any = [];
  @ViewChildren("inputRefp") myInputs!: QueryList<ElementRef>;
  @ViewChildren("ngselectRefp") mySelects!: QueryList<ElementRef>;
  @ViewChild("formElementRef") formElementRef!: ElementRef;
  @ViewChild('content') content: any;
  @ViewChild('contentRent') contentRent: any;
  queryField = new FormControl();
  pathProfileImage = `${environment.apiUrl}/${environment.dirProfileImage}/`;
  securityForm: any;
  autoReference!: string;
  oldStore: any;
  subscriptionUpdateSore!: Subscription;
  paymentsConditions?: PaymentConditionsModel[];
  openNewAgent: { listing: boolean, selling: boolean } = { listing: false, selling: false };
  selected: { listing: any, selling: any } = { listing: null, selling: null };
  agentsExceptListing: any[] = [];
  agentsExceptSelling: any[] = [];
  saleFormGetAgentsFn = (type: 'listing' | 'selling') => this.getAgents(type);
  saleFormGetStoreByIdFn = (id: any) => this.getStoreById(id);
  saleFormGetSuffixFn = () => this.getSuffix();
  formats: any[] = [
    {
      id: 1,
      description: this.translate.instant("t-developments.t-year-only"),
    },
    {
      id: 2,
      description: this.translate.instant("t-developments.t-year-month"),
    },
    {
      id: 3,
      description: this.translate.instant(
        "t-developments.t-year-month-day"
      ),
    },
  ];

  storeChangeResult: any;

  constructor(
    private eventService: EventService,
    private formBuilder: FormBuilder,
    private propertiesService: DevelopmentsService,
    private cdr: ChangeDetectorRef,
    private waitForElementService: WaitForElementService,
    public authService: AuthService,
    private modalService: NgbModal,
    private renderer: Renderer2,
    public permissionsService: PermissionsService,
    public translate: TranslateService,
    private toastService: ToastService
  ) {
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.stores = this.dataToFormInitDetails?.stores;
    this.propertyTypes = this.dataToFormInitDetails?.propertyTypes?.filter(
      (type: any) => type.development === true
    );
    this.conditions = this.dataToFormInitDetails?.conditions;
    this.businessStatus = this.dataToFormInitDetails?.businessStatus;
    this.saleId = this.dataToFormInitDetails?.saleId;
    this.rentIds = this.dataToFormInitDetails?.rentIds;
    this.typeRent = this.dataToFormInitDetails?.typeRent;
    this.ec = this.dataToFormInitDetails?.ec;
    this.businessTypes = this.dataToFormInitDetails?.businessTypes;
    this.currencies = this.dataToFormInitDetails?.currencies;
    this.selectDefaultStore = this.stores[0];

    if (this.quantityAvailable > 10) {
      for (let index = 0; index <= 50; index++) {
        this.nproperties.push(index);
      }
    } else {
      for (let index = 0; index < this.quantityAvailable; index++) {
        this.nproperties.push(index);
      }
    }

    this.refreshListings();

    this.initFormValidation();
  }

  ngAfterViewInit(): void {
    if (!this.subscriptionSubmitted)
      this.subscriptionSubmitted = this.eventService.subscribe(
        "get-data-tab-details-dev",
        () => {
          this.getTabDetails();
        }
      );

    // reference digitada pelo usuário → valida unicidade
    const refSub = this.propertyDetailsForm
      .get("reference")
      ?.valueChanges.pipe(debounceTime(200))
      .subscribe((data) => {
        this.ref = data?.trim();

        setTimeout(() => {
          if (this.isRefValid) {
            this.checkReference();
          } else {
            this.isRefValid = true;
          }

          this.getTabDetails();
        });
      });

    this.subscription.add(refSub);

    // (2) Store mudou → gera preview automático
    this.propertyDetailsForm
      .get("store")
      ?.valueChanges.pipe(debounceTime(300))
      .subscribe(() => {
        this.checkReference();
      });

    // (3) PropertyType mudou → gera preview automático
    this.propertyDetailsForm
      .get("propertyType")
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.checkReference();

        this.eventService.broadcast("get-data-tab-details-dev");
      });

    this.propertyDetailsForm
      .get("businessType")
      ?.valueChanges.subscribe((data) => {
        this.eventService.broadcast("get-data-tab-details-dev");
      });

    this.onChangeEC({ id: this.detailsForm?.data?.ec });

    this.submitted = true;

    this.isView = true;

    this.oldStore = this.propertyDetailsForm.get("store")?.value;

    this.checkReference();

    if (this.propertyDetailsForm.get("defineEndDate")?.value > 0) {
      this.disableEndDate();
    }

    const dateOfConstruction =
      this.propertyDetailsForm.get("yearOfConstruction")?.value;
    if (
      dateOfConstruction &&
      dateOfConstruction !== "" &&
      new Date(dateOfConstruction) > new Date("1951-08-07")
    ) {
      this.isShowUseLicense = true;
    } else {
      this.isShowUseLicense = false;
    }

    this.cdr.detectChanges();
    this.setEletemtConfig();

    this.propertyDetailsForm.get('businessType')?.valueChanges.subscribe((data) => {
      if (!this.property?.saleInProgress)
        this.eventService.broadcast('get-data-tab-details-dev');
    });
    this.propertyDetailsForm.get('condition')?.valueChanges.subscribe((data) => {
      this.eventService.broadcast('get-data-tab-details-dev');
    });
    this.propertyDetailsForm.get('businessStatus')?.valueChanges.subscribe((data) => {
      if (this.canChangeBusinessStatus && !this.property?.saleInProgress)
        this.eventService.broadcast('get-data-tab-details-dev');
    });

    this.propertyDetailsForm.get("ec")?.valueChanges.subscribe((data) => {
      this.eventService.broadcast("get-data-tab-details-dev");
    });

    this.propertyDetailsForm
      .get("propertyType2")
      ?.valueChanges.subscribe((data) => {
        this.eventService.broadcast("get-data-tab-details-dev");
      });

    this.propertyDetailsForm
      .get("associatedProperty")
      ?.valueChanges.subscribe((data) => {
        this.eventService.broadcast("get-data-tab-details-dev");
      });

    this.propertyDetailsForm
      .get("yearOfConstruction")
      ?.valueChanges.subscribe((data) => {
        if (data && data !== "" && new Date(data) > new Date("1951-08-07")) {
          this.isShowUseLicense = true;
        } else {
          this.isShowUseLicense = false;
        }
      });
    this.propertyDetailsForm.get('contractNumber')?.valueChanges.subscribe((data) => {
      this.eventService.broadcast('get-data-tab-details-dev');
    });
  }

  getSuffix() {
    return this.currencies.find(
      (c: any) => c?.id === this.propertyDetailsForm.get("currency")?.value
    )?.symbol;
  }

  /**
   * Form Validation
   */
  initFormValidation() {
    const validators = !this.dataToFormInitDetails.checkAutoRef
      ? [Validators.required, this.ValidateReference]
      : null;
    if (!this.property && !this.detailsForm?.data?.paymentsConditions) {
      this.paymentsConditions = [
        { type: 'SALE_AGREEMENT', valueType: 'PERCENTAGE', value: '50', paymentMoment: 'CPCV', agencyValue: '50', order: 1 },
        { type: 'DEED', valueType: 'PERCENTAGE', value: '50', paymentMoment: 'Escritura', agencyValue: '50', order: 2 },
      ]
    } else {
      this.paymentsConditions = this.detailsForm?.data?.paymentsConditions;
    }
    this.propertyDetailsForm = this.formBuilder.group({
      reference: [this.detailsForm?.data?.reference, validators],
      exclusive: [
        this.detailsForm?.data?.exclusive
          ? this.detailsForm?.data?.exclusive
          : false,
      ],
      store: [
        this.detailsForm?.data?.store
          ? this.detailsForm?.data?.store
          : this.selectDefaultStore.id,
        [Validators.required],
      ],
      propertyType: [
        this.detailsForm?.data?.propertyType
          ? this.detailsForm?.data?.propertyType
          : this.propertyTypes[0]?.id,
        [Validators.required, this.ValidatePropertyType],
      ],
      condition: [
        this.detailsForm?.data?.condition
          ? this.detailsForm?.data?.condition
          : this.conditions.find((s: any) => s.description === "---")?.id,
        [Validators.required, this.ValidateCondition],
      ],
      businessStatus: [
        this.detailsForm?.data?.businessStatus
          ? this.detailsForm?.data?.businessStatus
          : this.businessStatus.find((s: any) => s.description === "---")?.id,
        [Validators.required, this.ValidateBusinessStatus],
      ],
      yearOfConstruction: [this.detailsForm?.data?.yearOfConstruction], //>1952-01-25
      expectedConstructionStartDate: [
        this.detailsForm?.data?.expectedConstructionStartDate ?? null,
      ],
      expectedConstructionEndDate: [
        this.detailsForm?.data?.expectedConstructionEndDate ?? null,
      ],
      yearType: [
        this.detailsForm?.data?.yearType ? this.detailsForm?.data?.yearType : 1,
      ],
      ec: [this.detailsForm?.data?.ec],
      ecNumber: [this.detailsForm?.data?.ecNumber],
      ecExpirationDate: [this.detailsForm?.data?.ecExpirationDate],
      businessType: [
        this.detailsForm?.data?.businessType
          ? this.detailsForm?.data?.businessType
          : this.businessTypes.find((s: any) => s.description === "---")?.id,
        [Validators.required, this.ValidateBusinessType],
      ],
      price: [this.detailsForm?.data?.price],
      propertyValue: [this.detailsForm?.data?.propertyValue],
      startDateMediation: [this.detailsForm?.data?.startDateMediation],
      endDateMediation: [this.detailsForm?.data?.endDateMediation],
      defineEndDate: [this.detailsForm?.data?.defineEndDate],
      saleDate: [this.detailsForm?.data?.saleDate],
      dealId: [this.detailsForm?.data?.dealId ?? null],
      type: [this.type],
      nproperty: [
        this.detailsForm?.data?.nproperty
          ? this.detailsForm?.data?.nproperty
          : 0,
      ],
      associatedProperty: [this.detailsForm?.data?.associatedProperty],
      propertyType2: [this.detailsForm?.data?.propertyType2],
      legislation: [this.detailsForm?.data?.legislation],
      useLicense: [this.detailsForm?.data?.useLicense],
      buildingLicense: [this.detailsForm?.data?.buildingLicense],
      dateLicense: [this.detailsForm?.data?.dateLicense],
      technicalSheetLicense: [this.detailsForm?.data?.technicalSheetLicense],
      hidePrice: [this.detailsForm?.data?.hidePrice === true],
      hidePriceValue: [this.detailsForm?.data?.hidePriceValue === true],
      hideECNumber: [this.detailsForm?.data?.hideECNumber === true],
      hideECExpirationDate: [
        this.detailsForm?.data?.disableShowECExpirationDate === true,
      ],
      hideUseLicense: [this.detailsForm?.data?.hideECExpirationDate === true],
      hideDateLicense: [this.detailsForm?.data?.hideDateLicense === true],
      hideTechnicalSheetLicense: [
        this.detailsForm?.data?.hideTechnicalSheetLicense === true,
      ],
      hideBuildingLicense: [
        this.detailsForm?.data?.hideBuildingLicense === true,
      ],
      hideExclusive: [this.detailsForm?.data?.hideExclusive === true],
      inventoryValue: [this.detailsForm?.data?.inventoryValue],
      saleValue: [this.detailsForm?.data?.saleValue],
      saleCommission: [
        this.detailsForm?.data?.saleCommission
          ? this.detailsForm?.data?.saleCommission
          : this.dataToFormInitDetails?.commissions?.saleCommission,
      ],
      isPercentageCommission: [
        this.detailsForm?.data?.isPercentageCommission === undefined
          ? true
          : this.detailsForm?.data?.isPercentageCommission === true,
      ],
      sharedSale: [this.detailsForm?.data?.sharedSale],
      sharedCommission: [
        this.detailsForm?.data?.sharedCommission
          ? this.detailsForm?.data?.sharedCommission
          : 50,
      ],
      partnerEntityName: [this.detailsForm?.data?.partnerEntityName],
      renewableEnergy: [this.detailsForm?.data?.renewableEnergy],
      carbonEmissions: [this.detailsForm?.data?.carbonEmissions],
      hideCarbonEmissions: [
        this.detailsForm?.data?.hideCarbonEmissions === true,
      ],
      hideRenewableEnergy: [
        this.detailsForm?.data?.hideRenewableEnergy === true,
      ],
      methodPaymentCommission: [
        this.detailsForm?.data?.methodPaymentCommission
          ? this.detailsForm?.data?.methodPaymentCommission
          : 0,
      ],
      splitCommissionValue: [
        this.detailsForm?.data?.splitCommissionValue
          ? this.detailsForm?.data?.splitCommissionValue
          : this.detailsForm?.data?.saleCommission,
      ],
      currency: [
        this.detailsForm?.data?.currency
          ? this.detailsForm?.data?.currency
          : this.dataToFormInitDetails?.currencies?.find(
            (c: any) => c?.currencyCode === "EUR"
          )?.id,
      ],
      paymentsConditions: [this.paymentsConditions],
      contractNumber: [this.detailsForm?.data?.contractNumber?.toString() || '']
    });

    if (this.canChangeBusinessStatus === false) {
      this.propertyDetailsForm.controls['businessStatus'].disable();
    }
    if ((this.form['businessStatus']?.value === this.saleId || this.rentIds?.includes(this.form['businessStatus']?.value)) && this.property?.saleInProgress) {
      this.propertyDetailsForm.controls['businessStatus'].disable();
      this.propertyDetailsForm.controls['businessType'].disable();
    }
  }

  // uniqueUsernameValidator(): AsyncValidatorFn {
  //   return (
  //     control: AbstractControl
  //   ):
  //     | Promise<{ [key: string]: any } | null>
  //     | Observable<{ [key: string]: any } | null> => {
  //     const username = control.value;
  //     return this.propertiesService.checkReference(control.value).pipe(
  //       debounceTime(500),
  //       mapTo(null),
  //       catchError(() => of({ warning: true }))
  //     );
  //   };
  // }

  ValidateReference = (
    control: AbstractControl
  ): { [key: string]: any } | null => {
    if (this.property) {
      if (
        control?.value &&
        !this.isRefValid &&
        this.property?.reference !== control?.value
      ) {
        return { warning: true };
      }
    } else if (control?.value && !this.isRefValid) {
      return { warning: true };
    }
    return null;
  };

  ValidatePropertyType = (
    control: AbstractControl
  ): { [key: string]: any } | null => {
    const p = this.propertyTypes?.find((p: any) => p.id == control?.value);
    if (p && p.description === "---") {
      return { warning: true };
    }
    return null;
  };

  ValidateBusinessType = (
    control: AbstractControl
  ): { [key: string]: any } | null => {
    const p = this.businessTypes?.find((p: any) => p.id == control?.value);
    if (p && p.description === "---") {
      return { warning: true };
    }
    return null;
  };

  ValidateBusinessStatus = (
    control: AbstractControl
  ): { [key: string]: any } | null => {
    const p = this.businessStatus?.find((p: any) => p.id == control?.value);
    if (p && p.description === "---") {
      return { warning: true };
    }
    return null;
  };

  ValidateCondition = (
    control: AbstractControl
  ): { [key: string]: any } | null => {
    const p = this.conditions?.find((p: any) => p.id == control?.value);
    if (p && p.description === "---") {
      return { warning: true };
    }
    return null;
  };

  ValidateEC = (control: AbstractControl): { [key: string]: any } | null => {
    const p = this.ec?.find((p: any) => p.id == control?.value);
    if (p && p.description === "---") {
      return { warning: true };
    }
    return null;
  };

  ValidatePropertyType2 = (
    control: AbstractControl
  ): { [key: string]: any } | null => {
    const p = this.propertyTypes2?.find((p: any) => p.id == control?.value);
    if (p && p.description === "---") {
      return { warning: true };
    }
    return null;
  };

  /**
   * Form data get
   */
  get form() {
    return this.propertyDetailsForm.controls;
  }

  businessChange() {
    if (this.form['businessStatus'].value != this.saleId && !this.rentIds.includes(this.form['businessStatus'].value)) {
      this.form['saleDate'].setValue(null);
    } else {
      if (this.form['businessStatus'].value === this.saleId && this.securityForm?.businessStatus !== this.saleId) {
        this.openModal(this.content);
      } else if (this.rentIds.includes(this.form['businessStatus'].value) && !this.rentIds.includes(this.securityForm?.businessStatus)) {
        this.openModal(this.contentRent);
      }
    }
  }

  saveDetails() { }

  getFormErrors(): [] {
    let errors: any = [];
    Object.keys(this.propertyDetailsForm.controls).forEach((key) => {
      // Get errors of every form control
      let type = this.propertyDetailsForm?.get(key)?.errors;
      if (type) errors.push({ key: key, type: type });
    });
    return errors;
  }

  onChangeStore(event: any) {
    if (this.subscriptionUpdateSore) {
      this.subscriptionUpdateSore.unsubscribe();
    }

    const storeId = this.propertyDetailsForm.get("store")?.value || undefined;

    const updateAgents = () => {
      this.propertiesService.getDataForAgents(storeId).subscribe({
        next: (value) => {
          this.eventService.broadcast("store-data-to-form-init-agents-dev", value);
        },
        error: (err) => console.error(err),
      });

      this.subscriptionUpdateSore = this.eventService.subscribe(
        "set-store-data-to-form-init-agents-dev",
        (data2: any) => {
          this.propertyAgentsData = data2.propertyAgentsData;

          if (this.dataToFormInitDetails.checkAutoRef > 0) {
            const propertyTypeId =
              this.propertyDetailsForm.get("propertyType")?.value;

            const agentId = this.propertyAgentsData?.find(
              (agent: any) => agent.isMain
            )?.id;

            if (this.dataToFormInitDetails.checkAutoRef && !this.isUpdate) {
              if (storeId && propertyTypeId) {
                this.propertiesService
                  .previewReference(storeId, agentId, propertyTypeId)
                  .subscribe({
                    next: (data) => {
                      this.propertyDetailsForm.patchValue(
                        {
                          reference: data.reference,
                        },
                        { emitEvent: false }
                      );
                    },
                    error: () => {
                      this.propertyDetailsForm.patchValue({ reference: "" });
                    },
                  });
              }

              return;
            }
          }

          this.eventService.broadcast("get-data-tab-details-dev");

          if (this.storeChangeResult?.isDenied) {
            this.eventService.broadcast("change-tab-add-property-dev", 7);
          }
        }
      );

      this.subscription.add(this.subscriptionUpdateSore);
      this.oldStore = this.propertyDetailsForm.get("store")?.value;
    };

    if (this.propertyAgentsData.length > 0) {
      Swal.fire({
        title: this.translate.instant(
          "t-are-you-sure-you-want-to-change-agency"
        ),
        text: this.translate.instant(
          "t-this-change-may-remove-some-or-all-of-the-agents-that-are-associated-with-this-property"
        ),
        icon: "warning",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: this.translate.instant(
          "t-change-and-stay-in-the-details"
        ),
        denyButtonText: this.translate.instant(
          "t-change-and-go-to-agents"
        ),
        cancelButtonText: this.translate.instant("t-cancel"),
        customClass: {
          popup: "w-auto",
          confirmButton: "text-white btn bg-primary",
          denyButton: "text-white btn bg-info",
          cancelButton: "text-body btn bg-soft-dark",
          htmlContainer: "w-75 m-auto mt-2",
          title: "pt-2",
        },
      }).then((result) => {
        this.storeChangeResult = result;
        if (result.isConfirmed || result.isDenied) {
          updateAgents();
        } else {
          this.propertyDetailsForm.get("store")?.setValue(this.oldStore);
        }
      });
    } else {
      updateAgents();
    }
  }

  onChangePropertyType(event: any) {
    this.propertyDetailsForm.patchValue({ nproperty: 0 });
    const propertyType = this.propertyTypes.find(
      (p: any) => p.id === event?.id
    );
    this.type = propertyType.type;
    this.isNproperty = true;
    if (propertyType?.type === 2) {
      //fração
      this.propertyDetailsForm.get("associatedProperty")?.reset();
      this.propertyTypes2 = this.propertyTypes.filter(
        (pt: any) => pt.type !== 1 && pt.type !== 2 && pt.type !== 3
      );
      this.propertyDetailsForm
        .get("propertyType2")
        ?.setValidators([Validators.required, this.ValidatePropertyType2]);
      this.propertyDetailsForm.get("propertyType2")?.updateValueAndValidity();
      const propertyType2 = this.propertyTypes2?.find(
        (s: any) => s.description === "---"
      );
      if (propertyType2) {
        this.propertyDetailsForm.patchValue({
          propertyType2: propertyType2.id,
        });
      }

      this.propertyDetailsForm
        .get("associatedProperty")
        ?.setValidators([Validators.required]);
      this.propertyDetailsForm
        .get("associatedProperty")
        ?.updateValueAndValidity();
      //escolher
      //numero, empreendimento associado, tipo de fracçao
      if (this.propertyDetailsForm.get("store")?.value) {
        const propertiesSubscripion = this.propertiesService
          .getDevelopmentsByStore(this.propertyDetailsForm.get("store")?.value)
          .subscribe({
            next: (data) => {
              this.properties = data;
              if (this.properties.length > 0)
                this.propertyDetailsForm.patchValue({
                  associatedProperty: this.properties[0].id,
                });
            },
            error: (err) => {
              this.properties = [];
            },
          });
        this.subscription.add(propertiesSubscripion);
      }
      setTimeout(() => {
        this.eventService.broadcast("get-data-tab-details-dev");
      });
    } else if (propertyType?.type === 3) {
      // artigo
      this.propertyDetailsForm.get("associatedProperty")?.reset();
      const propertyType = this.propertyTypes.find(
        (p: any) => p.id === this.propertyDetailsForm.get("propertyType")?.value
      );
      if (propertyType)
        this.propertyTypes2 = this.propertyTypes.filter(
          (pt: any) =>
            (pt.groupId === propertyType.groupId && pt.type !== 3) ||
            pt.type === 4
        );
      else this.propertyTypes2 = undefined;
      this.propertyDetailsForm
        .get("propertyType2")
        ?.setValidators([Validators.required, this.ValidatePropertyType2]);
      this.propertyDetailsForm.get("propertyType2")?.updateValueAndValidity();
      const propertyType2 = this.propertyTypes2?.find(
        (s: any) => s.description === "---"
      );
      if (propertyType2) {
        this.propertyDetailsForm.patchValue({
          propertyType2: propertyType2.id,
        });
      }

      this.propertyDetailsForm
        .get("associatedProperty")
        ?.setValidators([Validators.required]);
      this.propertyDetailsForm
        .get("associatedProperty")
        ?.updateValueAndValidity();
      //escolher
      //numero, imovel associado, tipo de artigo
      if (
        this.propertyDetailsForm.get("store")?.value &&
        this.propertyDetailsForm.get("propertyType")?.value
      ) {
        const propertiesSubscripion = this.propertiesService
          .getPropertiesByStoreAndPropertyType(
            this.propertyDetailsForm.get("store")?.value,
            this.propertyDetailsForm.get("propertyType")?.value
          )
          .subscribe({
            next: (data) => {
              this.properties = data;
              if (this.properties.length > 0)
                this.propertyDetailsForm.patchValue({
                  associatedProperty: this.properties[0].id,
                });
            },
            error: (err) => {
              this.properties = [];
            },
          });
        this.subscription.add(propertiesSubscripion);
      }
      setTimeout(() => {
        this.eventService.broadcast("get-data-tab-details-dev");
      });
    } else {
      this.properties = [];
      this.propertyDetailsForm.get("propertyType2")?.setValidators(null);
      this.propertyDetailsForm.get("propertyType2")?.updateValueAndValidity();
      this.propertyDetailsForm.get("associatedProperty")?.setValidators(null);
      this.propertyDetailsForm
        .get("associatedProperty")
        ?.updateValueAndValidity();
      this.propertyDetailsForm.get("propertyType2")?.reset();
      this.propertyDetailsForm.get("associatedProperty")?.reset();
    }

    const store = this.propertyDetailsForm.get("store")?.value;
    const agentId = this.propertyAgentsData?.find((a: any) => a.isMain)?.id;
    const propertyTypeId = this.propertyDetailsForm.get("propertyType")?.value;

    if (this.dataToFormInitDetails.checkAutoRef && !this.isUpdate) {
      if (store && propertyTypeId) {
        this.propertiesService
          .previewReference(store, agentId, propertyTypeId)
          .subscribe({
            next: (data) => {
              this.propertyDetailsForm.patchValue(
                {
                  reference: data.reference,
                },
                { emitEvent: false }
              );
            },
            error: () => {
              this.propertyDetailsForm.patchValue({ reference: "" });
            },
          });
      }

      return;
    }

    setTimeout(() => {
      this.eventService.broadcast("get-data-tab-details-dev");
    });
  }

  onChangeUnitNumber(event: any) {
    if (this.type !== 2 && this.type !== 3)
      if (event > 0 && this.isNproperty) {
        this.isNproperty = false;
        if (this.type === 1) {
          this.propertyTypes2 = this.propertyTypes.filter(
            (pt: any) => pt.type !== 1 && pt.type !== 2 && pt.type !== 3
          );
          this.propertyDetailsForm
            .get("propertyType2")
            ?.setValidators([Validators.required, this.ValidatePropertyType2]);
        } else if (this.type === 4) {
          this.propertyTypes2 = undefined;
          this.propertyDetailsForm.get("propertyType2")?.setValidators(null);
          this.propertyDetailsForm
            .get("propertyType2")
            ?.updateValueAndValidity();
        } else if (this.type === 0) {
          //buscar tipo
          const propertyType = this.propertyTypes.find(
            (p: any) =>
              p.id === this.propertyDetailsForm.get("propertyType")?.value
          );
          if (propertyType)
            this.propertyTypes2 = this.propertyTypes.filter(
              (pt: any) =>
                (pt.groupId === propertyType.groupId && pt.type !== 3) ||
                pt.type === 4
            );
          else this.propertyTypes2 = undefined;

          this.propertyDetailsForm
            .get("propertyType2")
            ?.setValidators([Validators.required, this.ValidatePropertyType2]);
          this.propertyDetailsForm
            .get("propertyType2")
            ?.updateValueAndValidity();
        }
        let propertyType2 = this.propertyTypes2?.find(
          (s: any) =>
            s.id === this.propertyDetailsForm.get("propertyType2")?.value
        );
        if (!propertyType2)
          propertyType2 = this.propertyTypes2?.find(
            (s: any) => s.description === "---"
          );
        if (propertyType2) {
          this.propertyDetailsForm.patchValue({
            propertyType2: propertyType2.id,
          });
        }
      } else if (event === 0) {
        this.propertyDetailsForm.get("propertyType2")?.setValidators(null);
        this.propertyTypes2 = undefined;
        this.isNproperty = true;
      }
  }

  onChangeEC(ec1: any) {
    const ec = this.ec.find((ec2: any) => ec2.id === ec1.id);
    if (ec?.legislations?.length > 0) {
      this.legislations = ec.legislations;
    } else {
      this.propertyDetailsForm.patchValue({ legislation: null });
      this.legislations = undefined;
    }
  }

  onChangeDefineDate(event: any) {
    let dateStart = new Date();
    if (this.propertyDetailsForm.get("startDateMediation")?.value) {
      dateStart = new Date(
        this.propertyDetailsForm.get("startDateMediation")?.value
      );
    } else {
      this.propertyDetailsForm.patchValue({ startDateMediation: dateStart });
    }
    let dateEnd = new Date(dateStart);
    dateEnd.setMonth(dateStart.getMonth() + event);
    if (event)
      this.propertyDetailsForm.patchValue({ endDateMediation: dateEnd });
  }

  /**
   * `flatpickrChange` e não `change`: traz a data já lida pelo flatpickr, seja
   * escolhida no calendário ou escrita à mão. Ler `event.target.value` com o
   * campo em dd/mm/aaaa dava uma data americana (`new Date("12/10/2026")` é
   * 10 de dezembro).
   */
  onChangeStartDateMediation(event: any) {
    const dateStart: Date | undefined = event?.selectedDates?.[0];
    if (dateStart && this.propertyDetailsForm.get("defineEndDate")?.value > 0) {
      const dateEnd = new Date(dateStart);
      dateEnd.setMonth(
        dateStart.getMonth() +
        this.propertyDetailsForm.get("defineEndDate")?.value
      );
      this.propertyDetailsForm.patchValue({ endDateMediation: dateEnd });
    }
  }

  disableEndDate() {
    this.waitForElementService
      .waitForEl("#endDateMediation")
      .subscribe((data: any) => {
        data.disabled = true;
      });
  }

  openModal(content: any) {
    this.modalService.open(content, { size: 'xl', centered: true, backdropClass: 'custom-modal', scrollable: true });
  }


  setEletemtConfig() {
    if (
      !this.permissionsService.checkMasterPermission(
        "EDIT_PROPERTY_DETAILS",
        this.property?.store?.id
      ) &&
      !this.permissionsService.checkAgentPermission(
        this.property?.mainAgent,
        "EDIT_PROPERTY_DETAILS"
      ) &&
      this.property
    ) {
      this.securityForm = this.propertyDetailsForm.value;
    }

    if (
      !this.permissionsService.checkMasterPermission(
        "EDIT_PROPERTY_DETAILS",
        this.property?.store?.id
      ) &&
      !this.permissionsService.checkAgentPermission(
        this.property?.mainAgent,
        "EDIT_PROPERTY_DETAILS"
      ) &&
      this.property
    ) {
      if (this.formElementRef.nativeElement) {
        this.renderer.setStyle(
          this.formElementRef.nativeElement,
          "pointer-events",
          "none"
        );
        const parentElement = this.formElementRef.nativeElement.parentElement;

        if (parentElement) {
          this.renderer.setStyle(parentElement, "cursor", "not-allowed");
          const warning = parentElement.querySelectorAll(".is-warning");
          if (warning) {
            warning?.forEach((el: any) => {
              this.renderer.removeClass(el, "is-warning");
            });
          }
        }
      }
    }
  }

  /**
   * Checa referência: unicidade (manual) ou gera preview (automático)
   */
  checkReference() {
    const refCtrl = this.propertyDetailsForm.get("reference");
    this.ref = (refCtrl?.value ?? "").trim();

    const storeId = this.propertyDetailsForm.get("store")?.value || undefined;
    const propertyTypeId =
      this.propertyDetailsForm.get("propertyType")?.value || undefined;
    const agMain =
      this.propertyAgentsData?.find((agent: any) => agent.isMain) || undefined;
    const agentId = agMain?.id;

    // 🔹 Se autoRef = true → gera preview e substitui this.ref
    if (this.dataToFormInitDetails?.checkAutoRef && !this.isUpdate) {
      if (!this.ref) {
        const loader = document.querySelector(".propertyLoader2");
        this.renderer.removeClass(loader, "d-none");

        this.propertiesService
          .previewReference(
            Number.isFinite(+storeId) ? +storeId : undefined,
            agentId ?? undefined,
            Number.isFinite(+propertyTypeId) ? +propertyTypeId : undefined
          )
          .subscribe({
            next: ({ reference }) => {
              if (reference) {
                this.ref = reference.toUpperCase();
                refCtrl?.patchValue(this.ref);
                this.detailsForm.data.reference = this.ref;

                // bloqueia input visualmente
                setTimeout(() => {
                  if (this.dataToFormInitDetails?.checkAutoRef) {
                    this.myInputs.forEach((input: ElementRef) => {
                      if (input.nativeElement.id === "refereceInput") {
                        this.renderer.setStyle(
                          input.nativeElement,
                          "pointer-events",
                          "none"
                        );
                        this.renderer.addClass(
                          input.nativeElement,
                          "text-black-50"
                        );

                        const parent = input.nativeElement.parentElement;
                        if (parent)
                          this.renderer.setStyle(
                            parent,
                            "cursor",
                            "not-allowed"
                          );

                        const label = parent?.querySelector("label");
                        if (label)
                          this.renderer.setStyle(
                            label,
                            "cursor",
                            "not-allowed"
                          );
                      }
                    });
                  }
                });
              }
              this.renderer.addClass(loader, "d-none");
            },
            error: () => {
              this.isRefValid = false;
              this.renderer.addClass(loader, "d-none");
            },
          });
      } else {
        this.validateUniqueReference(refCtrl);
      }

      return;
    }

    // 🔹 Se autoRef = false → apenas valida unicidade do que foi digitado
    if (
      this.ref &&
      this.property?.reference !== this.ref &&
      !this.dataToFormInitDetails.checkAutoRef
    ) {
      this.validateUniqueReference(refCtrl);
    }
  }

  private validateUniqueReference(refCtrl: AbstractControl | null) {
    this.propertiesService.checkReference(this.ref).subscribe({
      next: ({ unique }) => {
        this.isRefValid = unique;

        if (!unique) {
          refCtrl?.addValidators(this.ValidateReference);
          refCtrl?.updateValueAndValidity();
        }
      },
      error: () => (this.isRefValid = false),
    });
  }

  getTabDetails() {
    const statusDisabled = this.propertyDetailsForm.controls['businessStatus'].disabled;
    if (statusDisabled) {
      this.propertyDetailsForm.controls['businessStatus'].enable();
    }
    if (this.form['businessStatus']?.value === this.saleId || this.rentIds.includes(this.form['businessStatus']?.value)) {
      if (this.form['price']?.value && (!this.form['saleValue'].value || this.form['saleValue'].value == 0)) {
        this.propertyDetailsForm.controls['saleValue'].setValue(Number(this.form['price'].value));
      }
      if (!this.form['saleDate'].value) {
        this.propertyDetailsForm.controls['saleDate'].setValue(new Date());
      }
    }
    if (!this.permissionsService.isMaster(this.propertiesService.getUserAuth().role?.name) && this.property && !this.permissionsService.hasPermission('EDIT_PROPERTY_DETAILS')) {
      this.propertyDetailsForm.setValue(this.securityForm);
    }

    this.propertyDetailsForm.patchValue({
      paymentsConditions: this.paymentsConditions,
    });

    this.detailsForm.data = this.propertyDetailsForm.value;
    this.detailsForm.errors = this.getFormErrors();
    this.detailsForm.valid = this.propertyDetailsForm.valid;
    if (statusDisabled) {
      this.propertyDetailsForm.controls['businessStatus'].disable();
    }
    this.cdr.detectChanges();
    this.eventService.broadcast('ckeck-warning-add-dev');
  }

  getPaymentConditionText(type: 'DEED' | 'SALE_AGREEMENT' | 'RESERVATION' | 'SIGNAL') {
    switch (type) {
      case 'DEED':
        return 't-new-sales.t-deed';
      case 'SALE_AGREEMENT':
        return 't-new-sales.t-sale-agreement';
      case 'RESERVATION':
        return 't-new-sales.t-reservation';
      case 'SIGNAL':
        return 't-new-sales.t-signal';
      default:
        return '';
    }
  }

  getPaymentConditionIcon(type: 'DEED' | 'SALE_AGREEMENT' | 'RESERVATION' | 'SIGNAL') {
    switch (type) {
      case 'DEED':
        return 'mdi-file-document-edit-outline';
      case 'SALE_AGREEMENT':
        return 'mdi-file-sign';
      case 'RESERVATION':
        return 'mdi-handshake-outline';
      case 'SIGNAL':
        return 'mdi-cash-fast';
      default:
        return '';
    }
  }

  getPaymentConditionValue(payment: { type: 'DEED' | 'SALE_AGREEMENT' | 'RESERVATION' | 'SIGNAL', valueType: 'PERCENTAGE' | 'FIXED', value: string }) {
    if (payment.valueType === 'PERCENTAGE') {
      const price = this.form['price']?.value ? Number(this.form['price']?.value) : 0;
      if (price) {
        const percentage = Number(payment.value);
        return `${this.priceFormat(this.formatNumber(price * (percentage / 100)))} (${percentage}%)`;
      } else {
        return `${payment.value} %`;
      }
    } else {
      const price = this.form['price']?.value ? Number(this.form['price']?.value) : 0;
      if (price) {
        const fixedValue = Number(payment.value);
        return `${this.priceFormat(payment.value)} (${this.formatNumber(fixedValue / price * 100)} %)`;
      } else {
        return `${this.priceFormat(payment.value)}`;
      }
    }
  }

  getPaymentConditionAgencyValue(payment: {
    type: 'DEED' | 'SALE_AGREEMENT' | 'RESERVATION' | 'SIGNAL',
    valueType: 'PERCENTAGE' | 'FIXED',
    value: string,
    agencyValue?: string // % da comissão da agência pago neste pagamento
  }) {
    const price = Number(this.form['price']?.value) || 0;

    if (price > 0) {
      // Comissão da agência (global)
      const agencyCommission = Number(this.form['saleCommission']?.value) || 0;
      const isPercentageCommission = !!this.form['isPercentageCommission']?.value;

      // Percentual (deste pagamento) que vai para a agência, mas sobre o TOTAL da comissão
      const agencyValuePct = Number(payment.agencyValue) || 0;

      // 1) Total da comissão da agência
      const commissionTotal = isPercentageCommission
        ? price * (agencyCommission / 100)   // ex.: 5% do preço
        : agencyCommission;                  // ex.: €5.000 fixo

      // 2) Parcela da comissão paga nesta fase
      const agencyValueThisPayment = commissionTotal * (agencyValuePct / 100);

      // Apresentação
      const valueStr = this.priceFormat(this.formatNumber(agencyValueThisPayment));
      const pctStr = ` (${this.formatNumber(agencyValuePct)}%)`; // % da COMISSÃO
      return valueStr + pctStr;
    } else {
      const agencyValue = Number(payment.agencyValue) || 0;
      return `${agencyValue}%`;
    }
  }


  formatNumber(value: number): string {
    return value % 1 === 0
      ? value.toString()           // se for inteiro, mostra sem casas decimais
      : value.toFixed(2);          // senão, mostra até 2 casas
  }

  priceFormat(propertyPrice: any, symbol: string = '€') {
    if (propertyPrice) {
      let price = propertyPrice.toString().split('.');
      const spaces = (price: any) =>
        String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, ' ');
      const price1 = spaces(price[0]);
      if (price.length > 1) return price1 + ',' + price[1] + ' ' + symbol;

      return price1 + ' ' + symbol;
    } return propertyPrice;
  }

  onPaymentChange(payment: any) {
    const price = this.form['price']?.value || 0;

    let totalFixed = 0;
    let totalPercent = 0;

    this.paymentsConditions?.forEach(p => {

      const value = Number((p.value || '0').toString().replace(/\s/g, ''));
      if (p === payment) return; // não somar o que está a ser editado

      if (p.valueType === 'FIXED') {
        totalFixed += value;
      } else if (p.valueType === 'PERCENTAGE') {
        totalPercent += value;
      }
    });

    const currentValue = Number((payment.value || '0').toString().replace(/\s/g, ''));

    if (price > 0) {
      const used = totalFixed + (totalPercent * price / 100);

      if (payment.valueType === 'FIXED') {
        const maxAllowed = price - used;
        if (currentValue > maxAllowed) {
          const suggestion = maxAllowed;
          if (this.toastService.toasts?.length === 0)
            this.showToast(payment.type, suggestion.toLocaleString(), '€');
        }
      } else if (payment.valueType === 'PERCENTAGE') {
        const maxAllowed = (price - used) / price * 100;
        if (currentValue > maxAllowed) {
          const suggestion = +maxAllowed.toFixed(2);
          if (this.toastService.toasts?.length === 0)
            this.showToast(payment.type, suggestion, '%');
        }
      }
    } else {
      // caso não haja preço, valida só percentuais
      if (payment.valueType === 'PERCENTAGE') {
        const maxAllowed = 100 - totalPercent;
        if (currentValue > maxAllowed) {
          const suggestion = +maxAllowed.toFixed(2);
          if (this.toastService.toasts?.length === 0)
            this.showToast(payment.type, suggestion, '%');
        }
      }
    }
  }

  showToast(text: any, value: any, type: '%' | '€') {
    const typeStr = this.translate.instant(this.getPaymentConditionText(text));
    const fullText = this.translate.instant('t-new-sales.t-total-commission-warning', { value1: typeStr, value2: value, value3: type });
    this.toastService.show(`⚠️ ${fullText}`, { classname: 'bg-warning text-white', delay: 4000 });
  }

  addPaymentCondition() {
    if (this.paymentsConditions)
      this.paymentsConditions?.push({
        type: 'SIGNAL',
        valueType: 'PERCENTAGE',
        value: '0',
        paymentMoment: '',
        agencyValue: '0',
        order: this.paymentsConditions?.length + 1
      });
    else this.paymentsConditions = [{
      type: 'SALE_AGREEMENT',
      valueType: 'PERCENTAGE',
      value: '50',
      paymentMoment: '',
      agencyValue: '50',
      order: 1
    }]
  }

  removePaymentCondition(index: number) {
    this.paymentsConditions?.splice(index, 1);
    this.reorderPayments();
  }

  drop(event: any) {
    moveItemInArray(this.paymentsConditions ?? [], event.previousIndex, event.currentIndex);
    this.reorderPayments();
  }

  reorderPayments() {
    this.paymentsConditions = this.paymentsConditions?.map((p, i) => ({ ...p, order: i + 1 }));
  }

  getAgents(type: 'listing' | 'selling') {
    if (type === 'listing')
      return this.propertyAgentsData?.filter((a: any) => a.isListingAgent);

    return this.propertyAgentsData?.filter((a: any) => a.isSellingAgent);
  }

  getStoreById(id: any) {
    return this.stores?.find((s: any) => s.id === id)?.name || '';
  }

  addAgent(type: 'listing' | 'selling') {
    this.selected[type] = null;
    this.openNewAgent[type] = true;
  }

  removeAgent(type: 'listing' | 'selling', id: any) {
    const agent = this.allAgents?.find((a: any) => a.id === id);
    if (agent) {
      if (type === 'listing') {
        agent.isListingAgent = false;
        const find = this.propertyAgentsData.find((ag: any) => ag.id == agent.id);
        if (find) {
          find.isListingAgent = false;
        }
      } else {
        agent.isSellingAgent = false;
        const find = this.propertyAgentsData.find((ag: any) => ag.id == agent.id);
        if (find) {
          find.isSellingAgent = false;
        }
      }

      this.refreshListings();
    }
  }

  onChangeAgent(id: any, type: 'listing' | 'selling') {
    if (id) {
      const agentData = this.allAgents?.find((a: any) => a.id === id);
      if (type === 'listing' && this.isStoreOperatorAgent(agentData)) {
        return;
      }

      if (!this.propertyAgentsData.find((ag: any) => ag.id == id)) {
        this.propertyAgentsData.push(agentData);
      }
      const agent = this.propertyAgentsData?.find((a: any) => a.id === id);
      if (agent) {
        if (type === 'listing' && this.isStoreOperatorAgent(agent)) {
          return;
        }
        agent.add = true;
        if (type === 'listing') {
          agent.isListingAgent = true;
          this.openNewAgent[type] = false;
          this.refreshListings();
        } else {
          agent.isSellingAgent = true;
          this.openNewAgent[type] = false;
          this.refreshListings();
        }

      }
    }
  }

  refreshListings() {
    this.agentsExceptListing = this.allAgents?.filter((a: any) => !this.isStoreOperatorAgent(a) && !this.propertyAgentsData?.filter((ag: any) => ag.isListingAgent).find((ag: any) => ag.id == a.id));
    this.agentsExceptSelling = this.allAgents?.filter((a: any) => !this.propertyAgentsData?.filter((ag: any) => ag.isSellingAgent).find((ag: any) => ag.id == a.id));
  }

  // Delegado ao PermissionsService: um STORE OPERATOR deixa de ser excluído
  // quando a entidade liga "diretores de loja também atuam como consultores".
  private isStoreOperatorAgent(agent: any): boolean {
    return !this.permissionsService.canBeListingAgent(agent);
  }

  ngOnDestroy(): void {
    if (this.propertyDetailsForm.controls['businessStatus'].disabled) {
      this.propertyDetailsForm.controls['businessStatus'].enable();
    }
    if (this.propertyDetailsForm.controls['businessType'].disabled) {
      this.propertyDetailsForm.controls['businessType'].enable();
    }
    this.subscriptionSubmitted.unsubscribe();
    this.subscription.unsubscribe();
    if (
      this.form["businessStatus"]?.value === this.saleId ||
      this.rentIds.includes(this.form["businessStatus"]?.value)
    ) {
      if (
        this.form["price"]?.value &&
        (!this.form["saleValue"].value || this.form["saleValue"].value == 0)
      ) {
        this.propertyDetailsForm.controls["saleValue"].setValue(
          Number(this.form["price"].value)
        );
      }
      if (!this.form["saleDate"].value) {
        this.propertyDetailsForm.controls["saleDate"].setValue(new Date());
      }
    }
    if (!this.form["currency"].value) {
      const eur = this.currencies?.find(
        (c: any) => c?.currencyCode === "EUR"
      )?.id;
      this.propertyDetailsForm.controls["currency"].setValue(eur);
    }

    this.propertyDetailsForm.patchValue({
      paymentsConditions: this.paymentsConditions,
    });

    if (
      !this.permissionsService.checkMasterPermission(
        "EDIT_PROPERTY_DETAILS",
        this.property?.store?.id
      ) &&
      !this.permissionsService.checkAgentPermission(
        this.property?.mainAgent,
        "EDIT_PROPERTY_DETAILS"
      ) &&
      this.property
    ) {
      this.propertyDetailsForm.setValue(this.securityForm);
    }
    this.detailsForm.data = this.propertyDetailsForm.value;
    this.detailsForm.errors = this.getFormErrors();
    this.detailsForm.valid = this.propertyDetailsForm.valid;
    this.cdr.detectChanges();
    this.eventService.broadcast("ckeck-warning-add-dev");
  }
}
